import React,{useState} from 'react';
import{DragDropContext,Droppable,Draggable} from "react-beautiful-dnd";
import {CircularProgress, LinearProgress} from '@material-ui/core';
import ImagenCarta from './ImagenCarta';
import useImagenesCarta from '../../Hooks/useImagenesCarta';
import realtimeDB, { storage } from '../../Utils/api';
import {useDropzone} from 'react-dropzone'
import PrimaryButton from "../PrimaryButton.jsx";
import styled from 'styled-components';
import uploadImage from '../../Utils/uploadImage';

const ContainerDropZone=styled.div`
margin:10px;
border:3px dashed;`;

const TextoDropZone=styled.p`
margin:0px;
padding:5% 10%;
text-align:center;`;

const TextoCargado=styled.p`
text-align: center;
font-size: 20px;
font-weight: 500;`;

const delay = ms => new Promise(res => setTimeout(res, ms));

const Cartas = ({firebaseId}) => 
{

    const Imagenes=useImagenesCarta(firebaseId);
    const [ImagenesCambiar, setImagenesCambiar] = useState([]);
    const [OrdenandoImagenes, setOrdenandoImagenes] = useState(false);

    const CartasList=()=>
    {
        const UploadImage=()=>
        {
            const UploadImage=()=>
            {
                const {getRootProps, getInputProps,isDragActive} = useDropzone({accept:"image/*", onDrop: imagenes=>
                {
                    imagenes.map(async imagen =>
                    {
                        const CartaRef= realtimeDB.ref(`/Cartas/${firebaseId}`);
                        const APIImagen=await uploadImage(imagen);
                        if(APIImagen.status===200)
                            CartaRef.child(`${Date.now()}`).set({source:APIImagen.path});
                    })
                }});
    
                return <section className="container">
                <ContainerDropZone {...getRootProps({className: 'dropzone'})}>
                  <input {...getInputProps()} />
                  {isDragActive ? <TextoDropZone>Suelta la imagen</TextoDropZone> : <TextoDropZone>Arrastrá o clickeá</TextoDropZone>}
                </ContainerDropZone>
              </section>
            }

            return <UploadImage/>
        }

        const BotonGuardarCambios=()=>
        {
            const Onclick=async()=>
            {
                setOrdenandoImagenes(true);
                await realtimeDB.ref(`/Cartas/${firebaseId}`).set(null);

                ImagenesCambiar.map(async (imagen,index) =>
                {
                    const {data}=imagen;
                    await realtimeDB.ref(`/Cartas/${firebaseId}/${index}`).set(data);
                })

                setImagenesCambiar([])
                setOrdenandoImagenes(false);
            }

            if(ImagenesCambiar.length>0)
            {
                return <PrimaryButton  style={{margin:"10px"}} onClick={Onclick}>guardar</PrimaryButton>
            }
            return "";
        }

        const ImagenesCarta=()=>
        {
            const handleOnDragEnd=async result=>
            {
                var imagenes=Imagenes;
                const [imagenesOrdenadas]=imagenes.splice(result.source.index,1);
                imagenes.splice(result.destination.index,0,imagenesOrdenadas);
                setImagenesCambiar(imagenes);
            }

            if(OrdenandoImagenes)
            {
                return <CircularProgress style={{margin:"40px auto",display:"flex"}}/>
            }
            return <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable style={{display:"block",margin:"0 auto"}} droppableId={`Droppable-Imagenes-${firebaseId}`} direction='horizontal'>
                {(provided)=> 
                {
                    return <section style={{display:"flex",justifyContent:"center"}} {...provided.droppableProps} ref={provided.innerRef}>
                    {Imagenes.map((imagen,index) =>
                    {
                       return <div  key={imagen.id} className="container-image">
                           <Draggable key={imagen.id} draggableId={imagen.id} index={index}>
                       {(provided) =>{ 
                            return <div style={{justifyContent:"center"}} {...provided.draggableProps} ref={provided.innerRef} {...provided.dragHandleProps}>
                                <ImagenCarta editando={ImagenesCambiar.length > 0 } imagen={imagen} firebaseId={firebaseId}/>
                            </div>}}
                    </Draggable></div>
                    })}
                      {provided.placeholder}
                    </section>
                }}
                </Droppable>      
            </DragDropContext>     
        }

        return <section>
            <UploadImage/>
            <BotonGuardarCambios/>
            <ImagenesCarta/>
        </section>
    }

    return <CartasList/>
}

export default Cartas
